<ng-template #modal class="js-cookie-consent cookie-consent">
    <div class="modal-header">
      <div class="title">Configurar cookies</div>
      <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="modal-body">

      <div class="col-12">   


          <div class="form-check mb-4" >
                 <input class="form-check-input" type="checkbox" value="" id="check_cookies0" checked disabled>
                 <label class="form-check-label" for="check_cookies1">
                   Técnicas y estrictamente necesarias (obligatorias)
                 </label>
                 <p class="mt-2">Son aquellas que resultan necesarias para el buen funcionamiento de la página web o para suministrar un servicio solicitado por el usuario respectivamente. En este sentido se consideran como necesarias y por tanto no sujetas a consentimiento informado aquellas cookies de personalización o preferencias que permiten recordar información para que el usuario acceda al servicio con determinadas características que puedan diferenciar su experiencia de la de otros usuarios, como por ejemplo serían el idioma o el número de resultados a mostrar en una búsqueda.</p>
           </div>

            <div class="form-check mb-5">
                 <input class="form-check-input" type="checkbox" value="" id="check_cookies1" (change)="googleCookieChanged($event)">
                 <label class="form-check-label" for="check_cookies1">
                   Analíticas
                 </label>
                 <p class="mt-2">Permiten reconocer y contabilizar el número de visitantes de nuestro sitio web, así como analizar su navegación y uso del mismo. Permitiendo realizar perfiles de navegación. No recopilan información de carácter personal. Entre estas se encuentran las cookies de Google Analitics, servicio de análisis web facilitado por Google, Inc. Para obtener más información sobre la como Google recoge y trata los datos pinche en  <a href="https://policies.google.com/privacy?hl=es" target="_blank" rel="noreferrer noopener">https://policies.google.com/privacy?hl=es</a></p>
           </div>

           <p class="mt-2">Puede consultar nuestra política de cookies en cualquier momento <a href="politica-cookies.html">aquí </a>o en la Web.</p>
          
          
           
           
          </div>
        </div>
        <div class="modal-footer">
          
          <button id="submitCookies" 
          (click)="saveAndClose()"
          class="btn-rco-cookies center-block" >Guardar y aceptar</button>
    
    </div>
  </ng-template>